export default "__VITE_ASSET__C$kq5TEW__"